// Third party
import * as yup from 'yup';
import dayjs, { Dayjs } from 'dayjs';

yup.setLocale({
  mixed: {
    required: '',
  },
});

const LoginSchema = yup.object().shape({
  identifier: yup.string().required(""),
  password: yup.string().required(""),
});

const ForgotPasswordSchema = yup.object().shape({
  email: yup.string().required('').email().trim(),
});

const RegisterSchema = yup.object({
  username: yup.string().trim().required(''),
  first_name: yup.string().trim().required(''),
  last_name: yup.string().trim().required(''),
  email: yup.string().required().email().trim(),
  phone: yup
    .string()
    .trim()
    .required(''),
  password: yup.string().required(''),
  retypePassword: yup
    .string()
    .oneOf([yup.ref('password')], 'Passwords must match')
    .required(''),
  date_of_birth: yup
    .mixed<Dayjs>()
    .required('')
    .test('is-valid', 'Invalid date', (value) => dayjs.isDayjs(value) && value.isValid?.())
    .test(
      'is-18',
      'Shooter must be at least 18 years old',
      (value) => dayjs.isDayjs(value) && dayjs().diff(value, 'year') >= 18
    ),
});

export { LoginSchema, ForgotPasswordSchema, RegisterSchema };